// Цветовая палитра приложения BuildFlow
// Все цвета вынесены в отдельный файл для удобной корректировки по макетам

export const colors = {
  // Основные цвета
  white: '#FFFFFF',

  // Оттенки серого
  gray50: '#FAFAFA',
  gray100: '#F5F5F5',
  gray200: '#EEEEEE',
  gray300: '#E0E0E0',
  gray400: '#BDBDBD',
  gray500: '#9E9E9E',
  gray600: '#808080',
  gray700: '#616161',
  gray800: '#3a3a3a',
  gray900: '#212121',

  // Акцентные цвета
  orange50: '#FFF3E0',
  orange100: '#FFE0B2',
  orange200: '#FFCC80',
  orange300: '#FFB74D',
  orange400: '#FFA726',
  orange500: '#ff6900',
  orange600: '#FB8C00',
  orange700: '#F57C00',
  orange800: '#EF6C00',
  orange900: '#FC4D02',

  blue: '#155DFC',

  black: '#000000',

  // Цвета статусов
  status: {
    received: {
      background: '#E8F5E8',
      text: '#2E7D32',
      icon: '#00c951'
    },
    expected: {
      background: '#FFF3E0',
      text: '#F57C00',
      icon: '#ff6900'
    },
    notProvided: {
      background: '#F5F5F5',
      text: '#757575',
      icon: '#9E9E9E'
    },
    error: {
      background: '#FDECEC',
      text: '#C62828',
      icon: '#E53935'
    }
  }
} as const
